import { PrinterOptionsSchema } from "@redotech/redo-model/printnode/printer";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

export const toteBarcodeFormatSchema = createEnum(["individual", "sheet"]);

export const printToteBarcodes = {
  name: "printToteBarcodes" as const,
  input: z.object({
    toteIds: z.array(z.string()),
    format: toteBarcodeFormatSchema.optional(),
    printerId: z.number().optional(),
    printerOptions: PrinterOptionsSchema.optional(),
    idempotencyKey: z.string().optional(),
  }),
  output: z.object({ url: z.string() }),
};

export type PrintToteBarcodesInput = z.infer<typeof printToteBarcodes.input>;
